import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import IDHelpers from '../../../../../../../core/helpers/IDHelper';
import { Block, Heading, Icon, Text } from '../../../../../../components';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line.svg';
import calendarIcon from '../../../../../../../assets/icons/icon-calendar.svg';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import routes from '../../../../../../components/Routes/routingMap';
import { InteractiveButton, ToggleCard } from '../../../../components';
import ModalConfirmation from '../../../../components/Modal/Modal';
import Spinner from '../../../../../../components/Spinner';
import { ButtonBack } from '../../../certificates-constancies/type1/info/components';
import CardInProgress from '../../../certificates-constancies/type1/progress/components/CardInProgress';
import ConfirmAction from '../../../certificates-constancies/type1/progress/components/ConfirmAction';
import ProgressDataUser from '../../../certificates-constancies/type1/progress/components/ProgressDataUser';
import { TextTitle } from '../../../certificates-constancies/type1/register/components';
import Processing from '@/presentation/components/Processing';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ContainerProcedure } from '../info/components';
import PinProcedure from '../../../../components/PinProcedure/PinProcedure';

const WrapLinkMoreInfo = styled.div`
  a {
    color: #5b36f2;
    text-decoration: underline;
    font-weight: bold;
  }
`;
export const evalChanges = (newData: any) => {
  let countChanges = 0;
  let htmlSubtitle = '';
  if (newData?.modality?.name) {
    countChanges += 1;
    htmlSubtitle += `Modalidad: <b>${newData?.modality?.name}</b><br />`;
  }
  if (newData?.campus?.name) {
    countChanges += 1;
    htmlSubtitle += `Campus: <b>${newData?.campus?.name?.replace(
      'Campus',
      ''
    )}</b><br />`;
  }
  if (newData?.program?.name) {
    countChanges += 1;
    htmlSubtitle += `Carrera: <b>${newData?.program?.name}</b><br />`;
  }
  if (countChanges === 1) {
    htmlSubtitle = `<div style="margin-bottom: 4px;">Tu cambio realizado:</div>${htmlSubtitle}`;
  } else if (countChanges > 1) {
    htmlSubtitle = `<div style="margin-bottom: 4px;">Tus cambios realizados:</div>${htmlSubtitle}`;
  }
  return htmlSubtitle;
};
interface ChangeCareerCampusModalityProgressViewProps {
  procedure: any;
  request: any;
  isLoading: boolean;
  isComplete: boolean;
  showModal: boolean;
  isLoadingCancel: boolean;
  isLoadingActivatePayment: boolean;
  showAnulate: boolean;
  isSuccessActivatePayment: boolean;
  isApproved: boolean;
  handlerStepAction: () => void;
  handlerCloseModal: () => void;
  handlerOkModal: () => void;
  handlerShowAnulate: () => void;
  linkSafe: any;
  pin1Safe: any;
  pin2Safe: any;
}

const ChangeCareerCampusModalityProgressView = (
  props: ChangeCareerCampusModalityProgressViewProps
) => {
  const {
    procedure,
    request,
    isLoading,
    isComplete,
    showModal,
    isLoadingCancel,
    isLoadingActivatePayment,
    showAnulate,
    isSuccessActivatePayment,
    isApproved,
    handlerStepAction,
    handlerCloseModal,
    handlerOkModal,
    handlerShowAnulate,
    linkSafe,
    pin1Safe,
    pin2Safe
  } = props;

  const history = useHistory();
  const isCreatedOrActived = ['CREADO', 'PAGO_ACTIVADO'].includes(
    request?.status?.status
  );
  let title = '';
  let subtitle = '';
  if (request?.status?.status === 'PAGO_REALIZADO') {
    title = 'Tu solicitud está en proceso';
    subtitle =
      'Te notificaremos por correo cuando tu solicitud esté finalizado.';
  }
  if (request?.status?.status === 'PROCEDE') {
    title = 'Tu solicitud ha sido aprobada';
    subtitle = `Tus cambios realizados:<br /> ${
      procedure?.detail?.newAcademicData?.modality?.name
        ? `Modalidad <b>${procedure?.detail?.newAcademicData?.modality?.name}</b> `
        : ''
    }${
      procedure?.detail?.newAcademicData?.campus?.name
        ? `en el ${
            procedure?.detail?.newAcademicData?.campus?.name
              .toUpperCase()
              .includes('CAMPUS')
              ? ''
              : 'campus'
          } <b>${procedure?.detail?.newAcademicData?.campus?.name}</b> `
        : ''
    }
${
  procedure?.detail?.newAcademicData?.program?.name
    ? `en la carrera de <b>${procedure?.detail?.newAcademicData?.program?.name}</b> `
    : ''
}estarán disponibles en un plazo de 3 días.`;
  }
  if (request?.status?.status === 'NO_PROCEDE') {
    title = 'Tu solicitud no procede';
    subtitle = request?.comentary || '';
  }
  return (
    <div data-testid="cmp-changecareercampusprogressview">
      <ContainerProcedure>
        <Processing isOpen={isLoadingCancel || isLoadingActivatePayment} />
        <ModalConfirmation
          show={showModal && !isLoadingCancel && !isLoadingActivatePayment}
          handleClose={handlerCloseModal}
        >
          <ConfirmAction
            activatePayment={request?.status?.status === 'CREADO'}
            gotoPayment={request?.status?.status === 'PAGO_ACTIVADO'}
            anulate={false}
            handleClickConfirm={handlerOkModal}
            handleClickCancel={handlerCloseModal}
            amount={procedure?.amount}
          />
        </ModalConfirmation>
        <ModalConfirmation
          show={isSuccessActivatePayment}
          handleClose={handlerCloseModal}
        >
          <ConfirmAction
            activatePayment={false}
            gotoPayment
            anulate={false}
            handleClickConfirm={handlerOkModal}
            handleClickCancel={handlerCloseModal}
            amount={procedure?.amount}
          />
        </ModalConfirmation>
        <ModalConfirmation
          show={showAnulate && !isLoadingCancel}
          handleClose={handlerCloseModal}
        >
          <ConfirmAction
            activatePayment={false}
            gotoPayment={false}
            anulate
            handleClickConfirm={handlerOkModal}
            handleClickCancel={handlerCloseModal}
            amount={procedure?.amount}
          />
        </ModalConfirmation>
        <ButtonBack
          onClick={() => history.push(routes.student.procedures.home)}
        />
        {isLoading && <Spinner />}
        {request && !isLoading && (
          <>
            <ToggleCard>
              {/* {toggleTitle} */}
              <Text
                color="#161D1F"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="900"
              >
                {procedure?.name}
              </Text>
              <Block
                customized
                flexDirection="column"
                alignItems="center"
                margin="0px 0px 12px 0px"
              >
                {request?.status?.status && (
                  <Block
                    flexDirection="row"
                    customized
                    margin="8px 0px 0px 0px"
                  >
                    <Block flexDirection="row" customized width="100%">
                      <Block
                        customized
                        alignItems="center"
                        padding="2px 0px 3px 0px"
                        borderRadius="4px"
                        maxWidth="84px"
                        backgroundColor={
                          [
                            'PENDIENTE',
                            'CREADO',
                            'PAGO_ACTIVADO',
                            'PAGO_REALIZADO'
                          ].includes(request?.status?.status)
                            ? '#977100'
                            : '#7A959F'
                        }
                      >
                        <Text
                          color="#FFFFFF"
                          fontSize="14px"
                          lineHeight="16px"
                          fontWeight="900"
                        >
                          {request?.status?.name}
                        </Text>
                      </Block>
                      <>
                        <Icon
                          customized
                          maxWidth="1px"
                          margin="0px 8px 0px 8px"
                          justifyContent="center"
                          alignItems="center"
                          height="20px"
                        >
                          <img src={lineIcon} alt="other" />
                        </Icon>
                        <Text
                          color="#161D1F"
                          fontSize="14px"
                          lineHeight="20px"
                          fontWeight="400"
                        >
                          {request?.status?.description}
                        </Text>
                      </>
                    </Block>
                  </Block>
                )}
                {isMobile ? (
                  <Block
                    customized
                    flexDirection="column"
                    alignItems="center"
                    margin="8px 0px 0px 0px"
                  >
                    <Block customized flexDirection="row">
                      <Icon
                        customized
                        maxWidth="16.9px"
                        height="15px"
                        margin="0px 4.67px 0px 0px"
                      >
                        <img src={moneyIcon} alt="other" />
                      </Icon>
                      <Text
                        color="#161D1F"
                        fontSize="14px"
                        lineHeight="20px"
                        fontWeight="400"
                      >
                        Costo:{' '}
                        <Text fontWeight="700">S/. {procedure?.amount}.00</Text>
                      </Text>
                    </Block>
                    <Block customized flexDirection="row" margin="6px 0px 0px">
                      <Icon
                        customized
                        maxWidth="13.33px"
                        margin="0px 5.33px 0px 0px"
                      >
                        <img src={calendarIcon} alt="other" />
                      </Icon>
                      <Text
                        color="#161D1F"
                        fontSize="12px"
                        lineHeight="16px"
                        fontWeight="400"
                      >
                        {procedure?.endDate || ''}
                      </Text>
                      <Icon
                        customized
                        maxWidth="1px"
                        height="13px"
                        margin="0px 0px 0px 16px"
                      >
                        <img src={lineIcon} alt="other" />
                      </Icon>
                      <Icon
                        customized
                        maxWidth="13.33px"
                        margin="0px 5.33px 0px 17.33px"
                      >
                        <img src={clockIcon} alt="other" />
                      </Icon>
                      <Text
                        color="#161D1F"
                        fontSize="12px"
                        lineHeight="16px"
                        fontWeight="400"
                      >
                        {procedure?.duration || ''}
                      </Text>
                    </Block>
                  </Block>
                ) : (
                  <Block
                    customized
                    flexDirection="row"
                    alignItems="center"
                    margin="8px 0px 0px 0px"
                  >
                    <Icon
                      customized
                      maxWidth="16.9px"
                      height="15px"
                      margin="0px 4.67px 0px 0px"
                    >
                      <img src={moneyIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="400"
                    >
                      Costo:{' '}
                      <Text fontWeight="700">S/. {procedure?.amount}.00</Text>
                    </Text>
                    <Icon
                      customized
                      maxWidth="1px"
                      height="13px"
                      margin="0px 0px 0px 16px"
                    >
                      <img src={lineIcon} alt="other" />
                    </Icon>
                    <Icon
                      customized
                      maxWidth="13.33px"
                      margin="0px 5.33px 0px 17.33px"
                    >
                      <img src={calendarIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                    >
                      {procedure?.endDate || ''}
                    </Text>
                    <Icon
                      customized
                      maxWidth="1px"
                      height="13px"
                      margin="0px 0px 0px 16px"
                    >
                      <img src={lineIcon} alt="other" />
                    </Icon>
                    <Icon
                      customized
                      maxWidth="13.33px"
                      margin="0px 5.33px 0px 17.33px"
                    >
                      <img src={clockIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                    >
                      {procedure?.duration || ''}
                    </Text>
                  </Block>
                )}
              </Block>
              {/* {toggleContent} */}
              <Block customized>
                <Block customized margin="0px 0px 16px 0px">
                  <WrapLinkMoreInfo>
                    <ul
                      style={{
                        listStyleType: 'disc',
                        display: 'block',
                        marginLeft: 16
                      }}
                    >
                      <li key={IDHelpers.generateID()}>{linkSafe}</li>
                    </ul>
                  </WrapLinkMoreInfo>
                </Block>
                <Heading
                  text="¿Qué requisitos necesito?"
                  level={3}
                  color="var(--text-text02)"
                  size={14}
                  lineHeight={20}
                  fontWeight="700"
                  className=""
                  align="flex-start"
                  width="auto"
                />
                <Block
                  customized
                  margin="12px 0px 0px 16px"
                  style={{ width: 'auto' }}
                >
                  <ul
                    style={{
                      listStyleType: 'disc',
                      display: 'block'
                    }}
                  >
                    {procedure?.requirements?.map((r: string) => (
                      <li key={IDHelpers.generateID()}>{r}</li>
                    ))}
                  </ul>
                </Block>
                <PinProcedure pinText={pin2Safe} />
                <PinProcedure pinText={pin1Safe} />
              </Block>
            </ToggleCard>
            <TextTitle title="Progreso" />
            <Block
              customized
              maxWidth={isMobile ? '100%' : '552px'}
              padding={isMobile ? '28px 0px 0px 8px' : '28px 0px 0px 16px'}
            >
              <Step
                isFirst
                name={procedure.steps[0].name}
                order={procedure.steps[0].order}
                date={procedure.steps[0].date?.toLowerCase()}
                isComplete={procedure.steps[0].isComplete}
                isCurrent={procedure.steps[0].isCurrent}
              >
                {procedure?.detail && (
                  <ProgressDataUser
                    newProgram={
                      procedure?.detail?.newAcademicData?.program?.name
                    }
                    newCampus={procedure?.detail?.newAcademicData?.campus?.name}
                    newModality={
                      procedure?.detail?.newAcademicData?.modality?.name
                    }
                  />
                )}
              </Step>
              <Step
                name={procedure.steps[1].name}
                order={procedure.steps[1].order}
                // date={isCreatedOrActived ? '' : procedure.steps[1].date}
                isComplete={!isCreatedOrActived}
                isCurrent={procedure.steps[1].isCurrent}
              >
                <>
                  <Text fontSize="12px">
                    {isCreatedOrActived ? '' : procedure.steps[1].date}
                  </Text>
                  {isCreatedOrActived && (
                    <CardInProgress
                      activatePayment={request.status.status === 'CREADO'}
                      paymentActivated={
                        request.status.status === 'PAGO_ACTIVADO'
                      }
                      isFinished={false}
                      subtitleText="Recuerda que una vez realizado el pago, se procederá con tu solicitud."
                      onClick={handlerStepAction}
                    />
                  )}
                </>
              </Step>
              <Step
                name={procedure.steps[2].name}
                order={procedure.steps[2].order}
                isComplete={isComplete}
                isCurrent={procedure.steps[2].isCurrent}
                disabled={!procedure.steps[2].isCurrent}
                isLast
              >
                <Text fontSize="12px">
                  {['PROCEDE', 'NO_PROCEDE'].includes(request.status.status)
                    ? procedure.steps[2].date?.toLowerCase()
                    : ''}
                </Text>
                {procedure.steps[2].isCurrent && (
                  <CardInProgress
                    activatePayment={false}
                    paymentActivated={false}
                    isPendingAtention={
                      request.status.status === 'PAGO_REALIZADO'
                    }
                    isComplete={isComplete}
                    isApproved={isApproved}
                    titleText={title}
                    subtitleText={
                      isComplete && isApproved
                        ? evalChanges(procedure?.detail?.newAcademicData)
                        : subtitle
                    }
                    textInfo
                  />
                )}
              </Step>
            </Block>

            {!isComplete && !(request.status.status === 'PAGO_REALIZADO') && (
              <Block style={{ alignSelf: isMobile ? 'center' : 'flex-start' }}>
                <InteractiveButton
                  bkgColorEnabled="none"
                  bkgColorHover="#E2DFFD"
                  bkgColorFocus="#C6C0FC"
                  bkgColorPressed="#C6C0FC"
                  customized
                  border="1px solid #5B36F2"
                  alignItems="center"
                  backgroundColor="#FFFFFF"
                  padding="9px 0px"
                  margin={isMobile ? '12px 0px 20px 0px' : '0px 0px 20px 0px'}
                  borderRadius="4px"
                  width="130px"
                  justifyContent={isMobile ? 'center' : 'flex-start'}
                  display="flex"
                  onClick={handlerShowAnulate}
                >
                  <Text
                    color="#5B36F2"
                    fontSize="14px"
                    lineHeight="20px"
                    fontWeight="700"
                    textAlign="center"
                    width="150px"
                  >
                    Anular solicitud
                  </Text>
                </InteractiveButton>
              </Block>
            )}
          </>
        )}
      </ContainerProcedure>
    </div>
  );
};

export default ChangeCareerCampusModalityProgressView;
